export const fixString = (string: string, maxLength: number, cut: boolean) => {
    if (!string || !string.length) return ''

    const text = string.replace(/([A-Z])/g, ' $1').trim()

    return cut ? ((text.length > maxLength) ? text.slice(0, maxLength-3) + '...' : text) : text
  }